import { el, setAttr } from 'redom';

import { stringToSVG } from 'utilities';
import { preventPropogation } from 'utilities/dom';

import Tooltip from '../tooltip';

import leaveMeetingIconString from 'assets/images/leave-meeting-icon.svg?raw';

const leaveMeetingIcon = stringToSVG(leaveMeetingIconString);

class LeaveMeetingControl {

  constructor(tooltipMessage, onLeave) {

    this.onLeave = onLeave;

    this.boundHandleLeaveButtonClick = this.handleLeaveButtonClick.bind(this);

    this.leaveButton = el('button.leave-meeting-button.meeting-room-control', leaveMeetingIcon.cloneNode(true));

    this.leaveButton.addEventListener('click', this.boundHandleLeaveButtonClick);
    this.leaveButton.addEventListener('dblclick', preventPropogation);

    this.el = new Tooltip(this.leaveButton, '.leave-button-tooltip', tooltipMessage);

  }

  onunmount() {
    this.leaveButton.removeEventListener('click', this.boundHandleLeaveButtonClick);
    this.leaveButton.removeEventListener('dblclick', preventPropogation);
  }

  handleLeaveButtonClick(event) {

    event.stopPropagation();

    setAttr(this.leaveButton, { disabled: true });

    this.onLeave(this.leaveButton);

    this.leaveButton.disabled = false;

  }

}

export default LeaveMeetingControl;